import { render } from "./ScenarioSelection.vue?vue&type=template&id=36a1b4a8"
import script from "./ScenarioSelection.vue?vue&type=script&lang=js"
export * from "./ScenarioSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__